import { createQueryKey } from '../../../../query/createQueryKeyFactory';
import { QueryKey } from '../../../../query/types';

const backerConsumerBackerIntentKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'intent'] as const;
  return createQueryKey({
    all: [...key] as const,
    detail: [...key, 'detail'] as const,
  });
};

export { backerConsumerBackerIntentKeys };
